import React from 'react';

/**
 * FE-FIX15. Панель массовых действий над событиями.
 *
 * Выбор страницы — master checkbox в шапке таблицы, поэтому здесь остались
 * только «все по фильтру» и «снять выбор». В режиме `filters` выбрано всё по
 * фильтру без списка id, а массовое изменение принимает только явные id, так
 * что кнопки изменения в этом режиме недоступны и объясняют почему.
 */
export const FILTER_MODE_BULK_HINT =
  'Массовое изменение работает только с событиями, отмеченными галочками. Снимите выбор по фильтру и отметьте события.';

const EventBulkActionsBar = ({
  total = 0,
  selectedCount = 0,
  mode = 'ids',
  onSelectAllByFilter,
  byFilterAvailable = true,
  onClear,
  onExclude,
  onRestore,
  busy = false,
  notice = '',
  error = '',
}) => {
  const nothingSelected = selectedCount === 0;
  const byFilter = mode === 'filters';
  const bulkDisabled = busy || nothingSelected || byFilter;
  const bulkTitle = byFilter ? FILTER_MODE_BULK_HINT : undefined;

  return (
    <div className="vio-bulk-bar">
      <div className="vio-bulk-counts">
        <span>Всего {total}</span>
        <span>Выбрано {selectedCount}</span>
      </div>

      <div className="vio-bulk-actions">
        <button
          type="button"
          className="vio-btn"
          onClick={onSelectAllByFilter}
          disabled={busy || byFilter || total === 0 || !byFilterAvailable}
        >
          Выбрать все по фильтру ({total})
        </button>
        <button type="button" className="vio-btn" onClick={onClear} disabled={busy || nothingSelected}>
          Снять выбор
        </button>
      </div>

      <div className="vio-bulk-actions">
        <button
          type="button"
          className="vio-btn vio-btn--primary"
          onClick={onExclude}
          disabled={bulkDisabled}
          title={bulkTitle}
        >
          Не включать в аналитику
        </button>
        <button
          type="button"
          className="vio-btn"
          onClick={onRestore}
          disabled={bulkDisabled}
          title={bulkTitle}
        >
          Вернуть в аналитику
        </button>
      </div>

      {notice && <p className="vio-notice">{notice}</p>}
      {error && <p className="vio-field-error">{error}</p>}
    </div>
  );
};

export default EventBulkActionsBar;
